module.exports = __webpack_public_path__ + "static/img/4bg_10.0c55f6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_10.png
// module id = 704
// module chunks = 1